import React, { useState } from 'react'
import { useHistory, useParams, useLocation } from 'react-router-dom'
import Container from '@material-ui/core/Container'
import Grid from '@material-ui/core/Grid'
import Button from '@material-ui/core/Button'
import Box from '@material-ui/core/Box'
import CoachOfferingCard from 'components/coach-offering-card'
import StepDesciptionOfferings from '../step-description-offerings'
import { useStyles } from './styles'
import LocationDropdown from './location-dropdown'
import UngroupedLessonTypes from './ungrouped-lesson-types'
import { IconButtonBackArrow } from 'components/atoms/icons'
import { flags, useFeatureFlags } from 'lib/feature-flags'
import { useAuth } from 'lib/auth'
import CoachMobileContactBanner from 'components/coach-contact-banners/coach-mobile-contact-banner'
import CoachLargeContactBanner from 'components/coach-contact-banners/coach-large-contact-banner'
import { useIsTablet } from 'lib/hooks'
import CoachGroupEvents from './coach-group-events'
import PropTypes from 'prop-types'

const PickLessonTypeLayoutWithLeadForm = ({
  data,
  coach,
  coachIsViewingOwnSchedule,
  lessonCreditBalances,
}) => {
  const { coachName, coachLocations, lessonTypes } = data
  const [selectedFacility, setSelectedFacility] = useState(null)
  const [groupEventsLocations, setGroupEventsLocations] = useState([])
  const [
    isLeadIntakeFormEnabled,
    isCoachOfferingsRefreshEnabled,
  ] = useFeatureFlags([
    flags.FLAG_FEAT_LEAD_INTAKE_STEPPER_FORM,
    flags.FLAG_FEAT_COACH_OFFERING_REFRESH,
  ])
  const classes = useStyles()
  const history = useHistory()
  const location = useLocation()
  const { idOrSlug } = useParams()
  const { isConsumer } = useAuth()
  const isTablet = useIsTablet()
  const [hasOneLocaton, setHasOneLocation] = useState(false)

  const lessonTypesSingleLesson = {}
  const lessonTypesWithPacks = {}

  const selectOfferingsText = 'Select from this list of coach offerings below.'
  const description = hasOneLocaton
    ? selectOfferingsText
    : `${selectOfferingsText} You can filter by the coach's available locations as well.`

  let hasLessonPacks = false
  const addSession = (recipient, lt, session) => {
    if (!Array.isArray(recipient[lt])) {
      recipient[lt] = []
    }
    recipient[lt].push(session)
  }

  Object.entries(lessonTypes).forEach(([lessonType, sessions]) => {
    sessions.forEach(session => {
      if (session.lessonPacks.length > 0) {
        hasLessonPacks = true
        addSession(lessonTypesWithPacks, lessonType, session)
        addSession(lessonTypesSingleLesson, lessonType, session)
      } else {
        addSession(lessonTypesSingleLesson, lessonType, session)
      }
    })
  })

  const handleGetInTouchClick = () => {
    history.push(
      `/coach/${idOrSlug}/schedule/intake-form?returnTo=${location.pathname}`,
      { coach: coach },
    )
  }

  return (
    <Container className={classes.outerContainer} pb={10}>
      <Grid>
        {isConsumer && (
          <Grid item xs={12}>
            <Box display="flex" flexGrow={1}>
              <Button
                href="/club"
                rel="noopener noreferrer"
                className={classes.navigation}
                startIcon={<IconButtonBackArrow />}
              >
                Back
              </Button>
            </Box>
          </Grid>
        )}
        {!isConsumer && coach.profileUrl != null && (
          <Grid item xs={12}>
            <Box display="flex" flexGrow={1}>
              <Button
                href={coach.profileUrl}
                rel="noopener noreferrer"
                className={classes.navigation}
                startIcon={<IconButtonBackArrow />}
              >
                Back
              </Button>
            </Box>
          </Grid>
        )}
        {/* coach information section */}
        <Grid item xs={12}>
          <CoachOfferingCard
            coach={{
              name: coachName,
              coachProfile: coach.coachProfile,
            }}
          />
        </Grid>
        {/* Coach Offerings section */}
        <Grid item xs={12}>
          <StepDesciptionOfferings
            title="Coach Offerings"
            description={description}
          />
          {!hasOneLocaton && (
            <Grid
              item
              xs={12}
              sm={6}
              md={4}
              className={classes.locationDropdown}
            >
              <LocationDropdown
                selectedFacility={selectedFacility}
                setSelectedFacility={setSelectedFacility}
                locations={coachLocations}
                groupEventsLocations={groupEventsLocations}
                setHasOneLocation={setHasOneLocation}
              />
            </Grid>
          )}
          <Grid item xs={12}>
            {hasLessonPacks && !coachIsViewingOwnSchedule && (
              <UngroupedLessonTypes
                title="Lesson Packs"
                selectedFacility={selectedFacility}
                lessonTypes={lessonTypesWithPacks}
                coachName={coachName}
                coachExternalId={coach?.externalId}
                classes={classes}
                isSingleSession={false}
                lessonCreditBalances={lessonCreditBalances}
                isRefreshedOfferings={isCoachOfferingsRefreshEnabled}
              />
            )}
            <UngroupedLessonTypes
              title="Private Instruction"
              selectedFacility={selectedFacility}
              lessonTypes={lessonTypesSingleLesson}
              classes={classes}
              lessonCreditBalances={lessonCreditBalances}
              isSingleSession={true}
              coachExternalId={coach?.externalId}
              coachName={coachName}
              coachIsViewingOwnSchedule={coachIsViewingOwnSchedule}
              isRefreshedOfferings={isCoachOfferingsRefreshEnabled}
            />
            <CoachGroupEvents
              coach={coach}
              selectedFacility={selectedFacility}
              setGroupEventsLocations={setGroupEventsLocations}
            />
            {isLeadIntakeFormEnabled &&
              !coachIsViewingOwnSchedule &&
              (isTablet ? (
                <CoachMobileContactBanner
                  coach={coach}
                  handleGetInTouchClick={handleGetInTouchClick}
                />
              ) : (
                <CoachLargeContactBanner
                  coach={coach}
                  handleGetInTouchClick={handleGetInTouchClick}
                />
              ))}
          </Grid>
        </Grid>
      </Grid>
    </Container>
  )
}
PickLessonTypeLayoutWithLeadForm.propTypes = {
  data: PropTypes.object.isRequired,
  coach: PropTypes.shape({
    coachProfile: PropTypes.shape({
      profileUrl: PropTypes.string,
    }),
    externalId: PropTypes.string,
  }),
  lessonCreditBalances: PropTypes.array,
  coachIsViewingOwnSchedule: PropTypes.bool,
}

export default PickLessonTypeLayoutWithLeadForm
